import React from 'react'

type FlexProps = {
  children?: React.ReactNode
  testId?: string
} & Pick<
  React.CSSProperties,
  | 'alignSelf'
  | 'flex'
  | 'flexWrap'
  | 'flexDirection'
  | 'justifyContent'
  | 'alignItems'
  | 'alignContent'
  | 'gap'
  | 'minWidth'
>

export const Flex = ({
  testId,
  flex,
  alignSelf,
  justifyContent,
  flexDirection,
  alignItems,
  gap,
  alignContent,
  flexWrap,
  children,
  minWidth,
}: FlexProps) => (
  <div
    data-testid={testId}
    style={{
      alignSelf,
      display: 'flex',
      justifyContent,
      flexDirection,
      flexWrap,
      gap,
      alignItems,
      alignContent,
      flex,
      minWidth,
    }}
  >
    {children}
  </div>
)
